import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { userTypesCaregivers } from 'config/constants';
import ROUTES from 'config/routes';
import ROLES from 'config/roles';


const CompanyRoute = ({ component: Component, ...rest }) => {
  const { isAuth, role } = rest;
  return (
    <Route
      {...rest}
      render={props => (
        isAuth && userTypesCaregivers.find(item => item.slug === role && role !== ROLES.FAMILY_OR_FRIEND)
          ? <Redirect to={ROUTES.profileInfo} />
          : <Component {...props} />
      )} />
  )
}

export default connect(
  state => {
    return {
      isAuth: state.auth.isAuth,
      role: state.auth.role,
    }
  }
)(CompanyRoute);